import { render, staticRenderFns } from "./LiquidacaoCardsTotalizadores.vue?vue&type=template&id=b6f9dbf2"
import script from "./LiquidacaoCardsTotalizadores.vue?vue&type=script&lang=js"
export * from "./LiquidacaoCardsTotalizadores.vue?vue&type=script&lang=js"
import style0 from "./LiquidacaoCardsTotalizadores.vue?vue&type=style&index=0&id=b6f9dbf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports